export const concatenateFileSystemNodePathToFilePath = (fileSystemNodePath, filePath) => {
    fileSystemNodePath = fileSystemNodePath.replace('\\', '/');
    filePath = filePath.replace('\\', '/');
    return (fileSystemNodePath + '/' + filePath).replace(/^\/+|\/+$/g, '').replace(/\/+/g,"/");
}

export const findQueueItem = (queue, id) => {
    return queue.find(queueItem => queueItem.id == id);
}